<template>
  <div class="topbar">
    <div class="breadcrumb">
      <span>{{ t('files.myFiles') }}</span>
    </div>
    <div class="actions">
      <BbBtn
        size="x-small"
        type="icon"
        icon="x-small"
        icon-size="medium"
        no-background
        @click="onDialogFilesClose"
      ></BbBtn>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import useModals from '~/composables/useModals';

export default {
  setup() {
    const { t } = useI18n();
    const { setShowFiles } = useModals();

    const onDialogFilesClose = () => setShowFiles(false);

    return {
      onDialogFilesClose,
      t,
    };
  },
};
</script>

<style scoped lang="scss">
.topbar {
  padding: $bb-spacing-3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $bb-neutral-0;
  border-bottom: 1px solid $bb-neutral-4;

  .breadcrumb {
    display: flex;
    align-items: center;

    button {
      padding: 0;
    }

    span {
      @include bb-regular-text-styles('sm');
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      max-width: 100%;
      font-weight: 500;
    }
  }

  .switch-public-mode {
    width: 200px;

    :deep(.switch-item) {
      background-color: $bb-neutral-0 !important;
    }

    :deep(.switch-item .v-slide-group__container .v-slide-group__content .v-tab--selected) {
      background-color: $bb-neutral-1;
    }

    :deep(.switch-item .v-slide-group__container .v-slide-group__content .v-tab) {
      &:active {
        background-color: $bb-neutral-1 !important;
      }

      &:hover {
        background-color: $bb-neutral-3 !important;
      }
    }
  }
}
</style>
